/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ListIamSecurityProfilesRequest,
    ListIamSecurityProfilesRequestFromJSON,
    ListIamSecurityProfilesRequestToJSON,
    ListIamSecurityProfilesResponse,
    ListIamSecurityProfilesResponseFromJSON,
    ListIamSecurityProfilesResponseToJSON,
} from '../models';

export interface PostIamSecurityProfilesRequest {
    listIamSecurityProfilesRequest?: ListIamSecurityProfilesRequest;
}

/**
 * 
 */
export class SecurityProfilesApi extends runtime.BaseAPI {

    /**
     */
    async postIamSecurityProfilesRaw(requestParameters: PostIamSecurityProfilesRequest): Promise<runtime.ApiResponse<ListIamSecurityProfilesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // CognitoAuthorizer authentication
        }

        const response = await this.request({
            path: `/iam-security-profiles/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ListIamSecurityProfilesRequestToJSON(requestParameters.listIamSecurityProfilesRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ListIamSecurityProfilesResponseFromJSON(jsonValue));
    }

    /**
     */
    async postIamSecurityProfiles(requestParameters: PostIamSecurityProfilesRequest): Promise<ListIamSecurityProfilesResponse> {
        const response = await this.postIamSecurityProfilesRaw(requestParameters);
        return await response.value();
    }

}
